export const initialCoctailData = {
  // _id: '', ?
  addTools: [],
  baseSpirit: [],
  category: [],
  color: null,
  country: null,
  degrees: null,
  description: null,
  difficulty: null,
  flavor: [],
  garnish: [],
  glassware: [],
  group: null,
  ingredients: null,
  media: null,
  methodMaking: [],
  name: '',
  origin: '',
  recommendedIds: [],
  cookingSteps: null,
  strength: [],
  timeForCocktail: [],
  tools: [],
  typeIce: [],
  typeServing: null,
  isVegan: false,
  volume: null,
  access: null,
};

export const initialCoctailValue = {
  _id: null,
  eng: initialCoctailData,
  ru: initialCoctailData,
};
